import { Box, Button, Checkbox, Container, FormControlLabel, Grid, TextField } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import CheckAndReturn from '../../../utility/CheckAndReturn';
import CardHeadMenu from '../CardHeadMenu/CardHeadMenu';
import configServ from '../../../services/config';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import StatusSubmitGrid from '../../Custom/CustomGrid/StatusSubmitGrid';
import { triggerLoader } from '../../../redux/reducers/LoaderTrigger';

// FUNCTION
const QuestionsCard = ({ isChanged, editData, setEditData }) => {
    //#region code
    const dispatch = useDispatch();
    const { user_id, company_id } = useSelector((state) => state.GlobalVariables);

    const initialFormData = {
        question: '',
        description: '',
        status: true
    }
    const [formData, setFormData] = useState(initialFormData);
    const [validationErrors, setValidationErrors] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [isCreate, setIsCreate] = useState(false);

    useEffect(() => {
        if (editData !== null) {
            setFormData(editData);
            setIsEdit(true);
            setIsCreate(true);
        }
        else {
            setIsEdit(false);
        }
    }, [editData]);

    const handlePopup = () => {
        try {
            if (isCreate === true) {
                handleReset();
            }
            setIsCreate(!isCreate);
        }
        catch (error) {
            console.log(error);
        }
    };

    const handleChange = (e) => {
        try {
            const { name, value, type, checked } = e.target;

            setFormData((prev) => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));

            if (validationErrors[name]) {
                setValidationErrors((prev) => ({
                    ...prev,
                    [name]: ''
                }));
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const validateForm = async () => {
        try {
            let errors = {};
            if (CheckAndReturn.checkError(formData.question)) {
                errors.question = "Required";
            }
            setValidationErrors(errors);
            return Object.values(errors).every(error => error === "");
        }
        catch (e) {
            console.log(e);
        }
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();

            dispatch(triggerLoader());
            const isValid = await validateForm();
            if (isValid === false) {
                return false;
            }
            const dataToSend = {
                ...formData,
                company_id: company_id,
                user_id: user_id
            }
            if (!isEdit) {
                const res = await configServ.createQuestion(dataToSend);
                if (res.status === 200) {
                    isChanged();
                    handleReset();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: res.message || 'Question created successfully.'
                    });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to create Question.'
                    });
                }
            }
            else {
                const res = await configServ.updateQuestion(dataToSend);
                if (res.status === 200) {
                    isChanged();
                    handleReset();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: res.message || 'Question updated successfully.'
                    });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to update Question.'
                    });
                }
            }
        }
        catch (e) {
            console.log(e);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred.'
            });
        }
        finally {
            dispatch(triggerLoader());
        }
    }

    const handleReset = () => {
        try {
            setFormData(initialFormData);
            setValidationErrors({});
            setEditData(null);
        }
        catch (e) {
            console.log(e);
        }
    }

    //#endregion

    return (
        <>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"QUESTIONS"}
                handlePopup={handlePopup}
                isEdit={isEdit}
                create={isCreate}
            />

            <Box width={'100%'} sx={{ my: 2 }} display={isCreate ? "block" : "none"}>
                <form onSubmit={handleSubmit} onReset={handleReset}>
                    <Grid container alignItems="flex-end" spacing={1} bgcolor={'#e3f3fc'} p={3} borderRadius={3}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size='small'
                                label='Question'
                                id='question'
                                name='question'
                                value={formData.question}
                                onChange={handleChange}
                                sx={{ background: 'white' }}
                                error={!!validationErrors.question}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size='small'
                                label='Description'
                                id='description'
                                name='description'
                                value={formData.description}
                                onChange={handleChange}
                                sx={{ background: 'white' }}
                                multiline
                                rows={2}
                            />
                        </Grid>
                        <StatusSubmitGrid status={formData.status || false} handleChange={handleChange} isEdit={isEdit} />
                    </Grid>
                </form>
            </Box>
        </>
    )
}

export default memo(QuestionsCard);
